var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlcohol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0843 21.0933H30.2109V16H36.0843V21.0933ZM57.9111 33.94C58.8111 35.5178 59.28 37.3556 59.28 39.2556C59.28 44.0667 56.2378 48.0667 52.2756 48.7733V60.1C54.5844 60.1933 56.3044 60.5444 56.3044 60.96C56.3044 61.4533 53.9556 61.8489 51.06 61.8489C48.1667 61.8489 45.8222 61.4533 45.8222 60.96C45.8222 60.5444 47.5422 60.1933 49.8511 60.1V48.7822C45.8489 48.1178 42.7644 44.1022 42.7644 39.2556C42.7644 37.3556 43.2356 35.5156 44.1333 33.94L44.3422 33.5667H57.6978L57.9111 33.94ZM44.2344 39.2511C44.2344 43.7489 47.2788 47.4022 51.0166 47.4022C54.7566 47.4022 57.8055 43.7511 57.8033 39.2511C57.8033 37.7556 57.4633 36.3067 56.8233 35.0378H45.2122C44.5699 36.3067 44.2344 37.7533 44.2344 39.2511ZM36.0867 22.66V27.4044C38.5711 28.5244 40.3 31.0178 40.2978 33.92V38.5711V53.4V62.1133H26V53.4V38.5711V33.92C26 31.0178 27.7333 28.5244 30.2133 27.4067V22.66H36.0867ZM39.0356 54.9244H27.3889V40.9511H39.0356V54.9244ZM51.12 46.7978C56.8822 46.7978 57.1911 39.4089 57.1911 39.4089H44.58C44.58 39.4089 45.3578 46.7978 51.12 46.7978Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/alcohol.fe3720bf72d26a52ca978c5f63bc2091.svg";
export { ForwardRef as ReactComponent };